import { TYPES } from "./var.type";
import moment from "moment";

const initState = {
  openAddGroup: false,
  openEditGroup: false,
  selectedDetailGroup: null,
  openAddService: false,
  openEditService: false,
  selectedDetailService: null,
  search: "",
  //job
  selectJobServices: [],
  openReceipt: false,
  openDetailReceipt: false,
  selected: null,

  //gift
  gift: null,
  //staff
  staff: "",
  assignStaff: null,

  //step
  step: 0,
  job: null,

  //feedback
  openFeedback: false,
  staffFeedback: "",

  //incomeStaff
  date: moment(),
  labelDate: moment().format("DD/MM/YYYY"),
  ignoreJob: true,
};

const varReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_OPEN_ADD_GROUP:
      return {
        ...state,
        openAddGroup: payload,
      };

    case TYPES.SET_OPEN_EDIT_GROUP:
      return {
        ...state,
        openEditGroup: payload,
      };

    case TYPES.SET_OPEN_ADD_SERVICE:
      return {
        ...state,
        openAddService: payload,
      };

    case TYPES.SET_OPEN_EDIT_SERVICE:
      return {
        ...state,
        openEditService: payload,
      };

    //select
    case TYPES.SELECT_DETAIL_GROUP:
      return {
        ...state,
        selectedDetailGroup: payload,
      };

    case TYPES.SELECT_DETAIL_SERVICE:
      return {
        ...state,
        selectedDetailService: payload,
      };

    //search
    case TYPES.SET_SEARCH:
      return {
        ...state,
        search: payload,
      };

    //jobs
    case TYPES.SELECT_JOB_SERVICE_SUCCESS:
      return {
        ...state,
        selectJobServices: payload,
      };

    case TYPES.SET_OPEN_RECEIPT:
      return {
        ...state,
        openReceipt: payload,
      };

    case TYPES.SET_OPEN_DETAIL_RECEIPT:
      return {
        ...state,
        openDetailReceipt: payload,
      };

    case TYPES.SELECT_RECORD_JOB_SUCCESS:
      return {
        ...state,
        selected: payload,
      };

    //gift
    case TYPES.SET_GIFT:
      return {
        ...state,
        gift: payload,
      };

    //staff
    case TYPES.SET_STAFF:
      return {
        ...state,
        staff: payload,
      };

    //assign staff
    case TYPES.SET_ASSIGN_STAFF:
      return {
        ...state,
        assignStaff: payload,
      };

    //assign staff
    case TYPES.SET_STEP:
      return {
        ...state,
        step: payload,
      };

    case TYPES.SET_JOB:
      return {
        ...state,
        job: payload,
      };

    case TYPES.SET_FEEDBACK:
      return {
        ...state,
        openFeedback: payload,
      };

    case TYPES.SET_FEED_STAFF:
      return {
        ...state,
        staffFeedback: payload,
      };

    //incomeStaff
    case TYPES.SET_DATE:
      return {
        ...state,
        date: payload,
      };

    case TYPES.SET_LABEL_DATE:
      return {
        ...state,
        labelDate: payload,
      };
    case TYPES.IGNORE_SELECT_JOB:
      return {
        ...state,
        ignoreJob: payload,
      };

    default:
      return state;
  }
};

export default varReducer;
